export enum ExportFormat {
    shp = 'shp',
    kml = 'kml',
    dgn = 'dgn',
    json = 'json',
    dxf = 'dxf',
    xlsx = 'xlsx',
}

export const getExportFormatCaption = (typ: string | ExportFormat): string => {
    switch (typ) {
        case ExportFormat.shp:
            return 'SHP';
        case ExportFormat.kml:
            return 'KML';
        case ExportFormat.dgn:
            return 'DGN';
        case ExportFormat.json:
            return 'JSON';
        case ExportFormat.dxf:
            return 'DXF';
        case ExportFormat.xlsx:
            return 'XLSX';
        default:
            return `_${typ}`;
    }
};

export const getExportFormatItems = (serverPublic: boolean): {id: ExportFormat; name: string}[] => {
    if (serverPublic) {
        // pro public režim zatím neumíme nic jiného než Excel
        return [{id: ExportFormat.xlsx, name: getExportFormatCaption(ExportFormat.xlsx)}];
    }
    return Object.keys(ExportFormat).map((t: ExportFormat) => ({id: t, name: getExportFormatCaption(t)}));
};
